import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout.vue'
import NoResult from './components/404.vue'
// import Home from './views/home.vue'

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // { path: '/ppst/:lang', name: 'ppst-lang', component: () => import('./views/ppst.vue') },

    {
      path: '/',
      name: 'pc',
      component: Layout,
      redirect: { name: 'events' },
      children: [
        { path: 'ppwc', name: 'events', component: () => import('./views/events.vue') }
        // { path: 'activate',
        //   name: 'upcoming-activate',
        //   redirect: { name: 'upcoming-activate-step1' },
        //   component: () => import('./views/eventsActivate.vue'),
        //   children: [
        //     { path: 'step1', name: 'upcoming-activate-step1', component: () => import('./views/activate/signForm1.vue') },
        //     { path: 'step2', name: 'upcoming-activate-step2', component: () => import('./views/activate/signForm2.vue') },
        //     { path: 'step3', name: 'upcoming-activate-step3', component: () => import('./views/activate/signTable.vue') },
        //     { path: 'step4', name: 'upcoming-activate-step4', component: () => import('./views/activate/signStep4.vue') },
        //     { path: 'step5', name: 'upcoming-activate-step5', component: () => import('./views/activate/signedTable.vue') }
        //   ] },
        // { path: 'activate',
        //   name: 'upcoming-activate-dec',
        //   component: () => import('./views/eventsActivate.vue'),
        //   children: [
        //     { path: ':dec', name: 'upcoming-activate-dec-step1', component: () => import('./views/activate/signForm1.vue') }
        //   ]
        // }
      ]
    },
    { path: '/privacy-policy', name: 'privacy-policy', component: () => import('./views/privacyPolicy.vue') },
    { path: '/user-agreement', name: 'user-agreement', component: () => import('./views/userAgreement.vue') },
    { path: '/privacy-policy-ppwc', name: 'privacy-policy-ppwc', component: () => import('./views/privacyPolicyPPWC.vue') },
    { path: '/user-agreement-ppwc', name: 'user-agreement-ppwc', component: () => import('./views/userAgreementPPWC.vue') },
    { path: '/user-agreement-ppwc-braze', name: 'user-agreement-ppwc-braze', component: () => import('./views/userAgreementPPWCBraze.vue') },
    {
      path: '*',
      name: 'NoResult',
      component: NoResult
    }
  ]
})

export default router
